const Filters={
  sexFilter:function(oldVal){
    return oldVal==1?'男':"女"
  },
  dateFilter:function(oldVal){
    return new Date(parseInt(oldVal)).toLocaleDateString();
  }
}

export default Filters;